import { html, TemplateResult } from 'lit-html';
import '../src/nile-loader/nile-loader';

export default {
  title: 'Components/NileLoader',
  component: 'nile-loader',
  argTypes: {
    height: { control: 'text', action: 'heightChange' },
    width: { control: 'text', action: 'widthChange' },
    position: { control: 'text', action: 'positionChange' },
    margin: { control: 'text', action: 'marginChange' },
  },
};

interface StoryArgs {
  height: string;
  width: string;
  position: string;
  margin: string;
}

const Template = ({ height, width, position, margin }: StoryArgs): TemplateResult<1> => {
  return html`
    <nile-loader
      .height="${height}"
      .width="${width}"
      .position="${position}"
      .margin="${margin}"
    ></nile-loader>
  `;
};

export const Default = (args: StoryArgs): TemplateResult<1> => Template(args);
Default.args = {
  height: '50',
  width: '50',
  position: 'absolute',
  margin: '',
};

export const Large = (args: StoryArgs): TemplateResult<1> => Template(args);
Large.args = {
  height: '100',
  width: '100',
  position: 'absolute',
  margin: '',
};
